import { useFormContext, Controller, FieldValues, Path } from 'react-hook-form';
import { Flex, Text, Checkbox } from '@radix-ui/themes';
import { CheckboxInputConfig } from '../../types';
import { FieldWrapper } from '../FieldWrapper';

export const CheckboxField = <TFormValues extends FieldValues>({
    config,
}: {
    config: CheckboxInputConfig<TFormValues>;
}) => {
    const { control } = useFormContext<TFormValues>();

    return (
        <FieldWrapper config={config}>
            <Controller
                name={config.name as Path<TFormValues>}
                control={control}
                rules={config.validation}
                render={({ field }) => (
                    <Text as='label' size='2'>
                        <Flex gap='2' align='center'>
                            <Checkbox
                                checked={field.value || false}
                                onCheckedChange={field.onChange}
                                onBlur={field.onBlur}
                            />
                            {config.label}{' '}
                            {config.validation?.required && (
                                <Text color='red'>*</Text>
                            )}
                        </Flex>
                    </Text>
                )}
            />
        </FieldWrapper>
    );
};
